import fetcher from '@api/fetchers/simpleFetcher';
import { getHost } from '@utils/api-helper/host';

import {
  ConsumeQuotaParams,
  ConsumeQuotaResponse,
  FetchQuotaParams,
  QuotaDetailsResponse,
  UnlockedEntityResponse
} from './types';

const host = getHost();

const PRIME_QUOTA_API = {
  DETAILS: 'v1/common/quota/details/',
  UPDATE: 'v1/common/quota/update/',
  UNLOCKED_ENTITY: 'v1/common/quota/unlocked_entity/'
} as const;

const getAuthOptions = (accessToken?: string) => {
  if (!accessToken) return {};

  return {
    authorization: accessToken
  };
};

export const getPrimeQuotaDetails = ({
  goalUID,
  accessToken
}: FetchQuotaParams): Promise<QuotaDetailsResponse> =>
  fetcher(`${host}${PRIME_QUOTA_API.DETAILS}?goal_uid=${goalUID}`, {
    ...getAuthOptions(accessToken)
  });

export const postPrimeQuotaConsumption = ({
  goalUID,
  objectUID,
  mode,
  accessToken
}: ConsumeQuotaParams): Promise<ConsumeQuotaResponse> =>
  fetcher(`${host}${PRIME_QUOTA_API.UPDATE}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      goal_uid: goalUID,
      mode_id: mode,
      usage: 1,
      check_quota: 'true',
      ...(objectUID && { meta_info: { object_uid: objectUID } })
    }),
    ...getAuthOptions(accessToken)
  });

export const getUnlockedEntityStatus = ({
  goalUID,
  accessToken
}: FetchQuotaParams): Promise<UnlockedEntityResponse> =>
  fetcher(`${host}${PRIME_QUOTA_API.UNLOCKED_ENTITY}?goal_uid=${goalUID}`, {
    ...getAuthOptions(accessToken)
  });
